class AnimateOnScroll {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.elements = [...document.querySelectorAll('.js-animate')]
    
    this.options = {
      rootMargin: '0px',
      threshold: 0.25
    }

    this.callback = (entries) => {
      entries.forEach((entry) => {
        const delay = entry.target.getAttribute('data-delay');

        if (entry.intersectionRatio >= 0.25 && delay) {
          setTimeout(() => {
              entry.target.classList.add("is-visible");
          }, delay)
        }

        if (entry.intersectionRatio >= 0.25) {
          if(entry.target.classList.contains('js-animate--image')) {
            setTimeout(() => {
                entry.target.classList.add("animate-in")
                entry.target.classList.add('is-visible')
            }, 100)
          } else {
            entry.target.classList.add('is-visible')
          }
        }
      })
    }

    const observer = new IntersectionObserver(this.callback, this.options)

    this.elements.forEach((element, index) => {
      observer.observe(element)
    })
  }
}

export default AnimateOnScroll
